export default __webpack_public_path__ + "static/media/logo-black.054d851d.svg";